export type ReasonType = 'refusal' | 'rework';
export type ReasonGroup = 'ads' | 'expert' | 'reviews';

export type BaseReason = {
    label: string;
    value: string;
    reasonType: ReasonType;
};

export const DEFAULT_ADS_REASONS: BaseReason[] = [
    {
        label: 'Низкое качество фотографий',
        value: 'К сожалению, не можем опубликовать объявление, так как фотографии сделаны в низком качестве, пожалуйста, отредактируйте объявление — загрузите фотографии в хорошем качестве',
        reasonType: 'rework'
    },
    {
        label: 'Несодержательные фотографии',
        value: 'К сожалению, не можем опубликовать объявление, так как фотографии не содержат полезной информации для экспертов — загрузите другие фотографии',
        reasonType: 'rework'
    },
    {
        label: 'Слишком мало фотографий',
        value: 'К сожалению, не можем опубликовать объявление, так как оно содержит слишком мало фотографий — загрузите больше',
        reasonType: 'rework'
    },
    {
        label: 'Выбрана неправильная категория',
        value: 'К сожалению, не можем опубликовать объявление, так как выбрана неправильная категория — исправьте объявление',
        reasonType: 'rework'
    },
    {
        label: 'Выбрана неправильная подкатегория',
        value: 'К сожалению, не можем опубликовать объявление, так как выбрана неправильная подкатегория — исправьте объявление',
        reasonType: 'rework'
    },
    {
        label: 'Ненормативная лексика в описании',
        value: 'К сожалению, не можем опубликовать объявление, так как описание содержит ненормативную лексику или персональные данные других пользователей — исправьте объявление',
        reasonType: 'rework'
    },
    {
        label: 'Описание содержит сторонние ссылки',
        value: 'К сожалению, не можем опубликовать объявление, так как описание содержит сторонние ссылки — удалите их',
        reasonType: 'rework'
    },
    {
        label: 'Описание содержит персональные данные',
        value: 'К сожалению, не можем опубликовать объявление, так как описание содержит персональные данные других пользователей — удалите их',
        reasonType: 'rework'
    },
    {
        label: 'Нарушает правила площадки',
        value: 'К сожалению, не можем опубликовать это объявление, так как оно нарушает правила нашей площадки',
        reasonType: 'refusal'
    },
    {
        label: 'Слишком плохое состояние вещи',
        value: 'К сожалению, не можем опубликовать объявление с этой вещью — слишком плохое состояние',
        reasonType: 'refusal'
    }
];

export const DEFAULT_EXPERT_REASONS: BaseReason[] = [
    {
        label: 'Не удалось проверить подлинность',
        value: 'К сожалению, не можем опубликовать объявление с этой вещью — эксперты не смогли проверить ее подлинность',
        reasonType: 'refusal'
    },
    {
        label: 'Без объяснения причин',
        value: 'К сожалению, не можем опубликовать это объявление, так как оно нарушает правила нашей площадки',
        reasonType: 'refusal'
    }
];

export const DEFAULT_REVIEW_REASONS: BaseReason[] = [
    {
        label: 'Персональная информация в тексте',
        value: 'К сожалению, отзыв не может быть опубликован, так как в нем присутствует персональная информация других пользователей',
        reasonType: 'refusal'
    },
    {
        label: 'Оскорбления в тексте',
        value: 'К сожалению, отзыв не может быть опубликован, так как текст содержит оскорбления',
        reasonType: 'refusal'
    },
    {
        label: 'Персональная информация на фото',
        value: 'К сожалению, отзыв не может быть опубликован, так как фотографии содержат персональную информацию других пользователей',
        reasonType: 'refusal'
    },
    {
        label: 'Низкий смысл',
        value: 'К сожалению, отзыв не может быть опубликован, так как текст не содержит полезной информации',
        reasonType: 'refusal'
    },
    {
        label: 'Другое',
        value: 'К сожалению, отзыв не может быть опубликован, так как он не прошел модерацию',
        reasonType: 'refusal'
    }
];
